import { Controller } from "@hotwired/stimulus"

// The "Choose a new password" checklist: as the password is typed, each
// rule line turns from a grey dot to a red X or a green check, and the
// length line shows the character count. The same rules as User's
// password_strength and Devise's length (12 to 128). The breach line is
// left alone: only the server can check it, on save. The Save button
// stays enabled, since the server is the real check. No live region: the
// list is the password field's description, so it is read on focus, not
// announced on every keystroke.
const STATE_CLASSES = {
  pending: "text-muted",
  bad: "text-bad",
  good: "text-good"
}

const STATUS_TEXT = {
  pending: ", not met",
  bad: ", not met",
  good: ", met"
}

const MINIMUM_LENGTH = 12

export default class extends Controller {
  static targets = ["password", "confirmation", "rule", "count", "status"]

  update() {
    const password = this.passwordTarget.value
    const confirmation = this.confirmationTarget.value
    const typed = password.length > 0
    const checks = {
      length: password.length >= MINIMUM_LENGTH,
      number: /\d/.test(password),
      special: /[^\p{L}\p{N}]/u.test(password),
      match: password === confirmation
    }

    this.ruleTargets.forEach((line) => {
      const rule = line.dataset.rule
      // A red breach line is about the password the server refused; once a
      // new one is typed it is unchecked again, so it goes back to grey.
      if (rule === "breach") {
        if (typed && line.dataset.state !== "pending") this.show(line, "pending", "")
        return
      }
      if (!(rule in checks)) return

      const started = rule === "match" ? confirmation.length > 0 : typed
      this.show(line, started ? (checks[rule] ? "good" : "bad") : "pending")
    })

    if (this.hasCountTarget) this.countTarget.textContent = typed ? ` (${password.length})` : ""
  }

  show(line, state, statusText = STATUS_TEXT[state]) {
    line.dataset.state = state
    Object.values(STATE_CLASSES).forEach((name) => line.classList.remove(name))
    line.classList.add(STATE_CLASSES[state])
    line.querySelectorAll("[data-icon]").forEach((icon) => {
      icon.hidden = icon.dataset.icon !== state
    })
    const status = line.querySelector("[data-password-rules-target='status']")
    if (status) status.textContent = statusText
  }
}
